module.exports = __webpack_public_path__ + "static/media/error_page_sales.aae6a230.png";